import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import { Icon } from '../Icon';
import httpsImageSrc from '../../assets/images/subscription/https.png';
import sslImageSrc from '../../assets/images/subscription/ssl.png';
import discoverImageSrc from '../../assets/images/subscription/discover.png';
import jcbImageSrc from '../../assets/images/subscription/jcb.png';
import securedImageSrc from '../../assets/images/subscription/norton-secured.png';
import maestroImageSrc from '../../assets/images/subscription/maestro.png';
import mcafeeImageSrc from '../../assets/images/subscription/mcafee.png';
import payPalImageSrc from '../../assets/images/subscription/pay-pal.png';
import mastercardImageSrc from '../../assets/images/subscription/mastercard.png';
import unionpayImageSrc from '../../assets/images/subscription/unionpay.png';
import visaImageSrc from '../../assets/images/subscription/visa.png';
import amexImageSrc from '../../assets/images/subscription/americanexpress.png';
import styles from './PaymentInformationBlock.css';

const cx = classnames.bind(styles);

function PaymentInformationBlock({
    className
}) {
    const { t } = useTranslation();
    const classes = cx({
        root: true,
        [className]: Boolean(className)
    });

    return (
        <div className={classes}>
            <div className={styles.safeBlock}>
                <Icon name='lock' />
                <span>{t('common.paySafeAndSecure')}</span>
            </div>
            <ul className={styles.list}>
                <li>
                    <img
                        alt='https'
                        src={httpsImageSrc}
                    />
                </li>
                <li>
                    <img
                        alt='ssl'
                        src={sslImageSrc}
                    />
                </li>
                <li>
                    <img
                        alt='discover'
                        src={discoverImageSrc}
                    />
                </li>
                <li>
                    <img
                        alt='jcb'
                        src={jcbImageSrc}
                    />
                </li>
                <li>
                    <img
                        alt='secured'
                        src={securedImageSrc}
                    />
                </li>
                <li>
                    <img
                        alt='maestro'
                        src={maestroImageSrc}
                    />
                </li>
                <li>
                    <img
                        alt='mcafee'
                        src={mcafeeImageSrc}
                    />
                </li>
                <li>
                    <img
                        alt='payPal'
                        src={payPalImageSrc}
                    />
                </li>
                <li>
                    <img
                        alt='mastercard'
                        src={mastercardImageSrc}
                    />
                </li>
                <li>
                    <img
                        alt='unionpay'
                        src={unionpayImageSrc}
                    />
                </li>
                <li>
                    <img
                        alt='visa'
                        src={visaImageSrc}
                    />
                </li>
                <li>
                    <img
                        alt='american express'
                        src={amexImageSrc}
                    />
                </li>
            </ul>
        </div>
    );
}

PaymentInformationBlock.propTypes = {
    className: PropTypes.string
};

PaymentInformationBlock.defaultProps = {
    className: ''
};

export {
    PaymentInformationBlock
};
